/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserCreateUserRequest
 */
export interface RevisdomAPIViewModelsUserCreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    role?: RevisdomAPIViewModelsUserCreateUserRequestRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    organizationName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    sendPasswordWithEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserCreateUserRequest
     */
    notificationToEmail?: boolean;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsUserCreateUserRequestRoleEnum = {
    Admin0: 'Admin (0)',
    Editor1: 'Editor (1)',
    Commenter2: 'Commenter (2)',
    Viewer3: 'Viewer (3)',
    SperYnetici4: 'Süper Yönetici (4)',
    Guest5: 'Guest (5)'
} as const;
export type RevisdomAPIViewModelsUserCreateUserRequestRoleEnum = typeof RevisdomAPIViewModelsUserCreateUserRequestRoleEnum[keyof typeof RevisdomAPIViewModelsUserCreateUserRequestRoleEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsUserCreateUserRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsUserCreateUserRequest(value: object): value is RevisdomAPIViewModelsUserCreateUserRequest {
    return true;
}

export function RevisdomAPIViewModelsUserCreateUserRequestFromJSON(json: any): RevisdomAPIViewModelsUserCreateUserRequest {
    return RevisdomAPIViewModelsUserCreateUserRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserCreateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserCreateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'title': json['title'] == null ? undefined : json['title'],
        'password': json['password'] == null ? undefined : json['password'],
        'role': json['role'] == null ? undefined : json['role'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'sendPasswordWithEmail': json['sendPasswordWithEmail'] == null ? undefined : json['sendPasswordWithEmail'],
        'notificationToEmail': json['notificationToEmail'] == null ? undefined : json['notificationToEmail'],
    };
}

export function RevisdomAPIViewModelsUserCreateUserRequestToJSON(json: any): RevisdomAPIViewModelsUserCreateUserRequest {
    return RevisdomAPIViewModelsUserCreateUserRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserCreateUserRequestToJSONTyped(value?: RevisdomAPIViewModelsUserCreateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'title': value['title'],
        'password': value['password'],
        'role': value['role'],
        'organizationName': value['organizationName'],
        'sendPasswordWithEmail': value['sendPasswordWithEmail'],
        'notificationToEmail': value['notificationToEmail'],
    };
}

